module.exports = __webpack_public_path__ + "static/btn_01-7db2042c68a63679099564209f27a7cf.png";